import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { CreateScheduleRequestDTO, RequestSchedulingResponse } from "@/types";

async function createScheduling(
  request: CreateScheduleRequestDTO
): Promise<RequestSchedulingResponse> {
  const response = await httpRequest.post<RequestSchedulingResponse>(
    "/schedulings",
    request
  );
  return response.data;
}

export function useCreateSchedulingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createScheduling,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedulings"] });
    },
  });
}
